import React from "react";
import moment from "moment";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postSwissportForm } from "../../redux/actions";

const PersonalInformationForm = ({ appData, postSwissportFormFunc }) => {
  const {
    firstName = "",
    lastName = "",
    emailAddress = "",
    nationalInsuranceNo = "",
    address: { addressLine1, addressLine2, town, postcode, county },
    mobileTelephone = "",
    title = "",
  } = {
    address: {
      addressLine1: "",
      addressLine2: "",
      town: "",
      postcode: "",
      county: "",
    },
    ...appData,
  }; // in case that candidate has no address

  const initialData = {
    firstName,
    lastName,
    emailAddress,
    dateOfBirth: appData.dateOfBirth
      ? moment(appData.dateOfBirth).format("DD/MM/YYYY")
      : "",
    nationalInsuranceNo,
    addressLine1,
    addressLine2,
    postTown: town,
    postCode: postcode,
    county,
    mobileTelephone,
    gender:
      appData.gender &&
      appData.gender.charAt(0).toUpperCase() + appData.gender.slice(1),
    age: appData.dateOfBirth
      ? moment()
          .diff(moment(appData.dateOfBirth).format("YYYY-MM-DD"), "years")
          .toString()
      : "",
    title,
  };

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";
  const validateTrue = (value) => !!value;
  const getVal = getField(initialData);

  const validateDDMMYYYY = (value) => {
    if (!value) return true;
    const date = moment(value, "DD/MM/YYYY", true);
    return date.isValid();
  };

  const initialState = {
    blurbSection1: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Current details"} />
        </div>
      ),
    },
    Group0: {
      title: "Title:",
      type: "radio",
      value: getVal("title"),
      radioOptions: ["N/A", "Mr", "Miss", "Mrs", "Ms"],
      mandatory: true,
    },
    lastNamePIF: {
      title: "Last Name:",
      value: getVal("lastName"),
      type: "text",
      mandatory: true,
    },
    firstNamePIF: {
      title: "Fist Name:",
      value: getVal("firstName"),
      type: "text",
      mandatory: true,
    },
    middleNamePIF: {
      title: "Middle Name:",
      value: getVal("middleName"),
    },
    dateOfBirth: {
      title: "Date of Birth:(dd/mm/yyyy)",
      value: getVal("dateOfBirth"),
      mandatory: true,
      type: "text",
      validate: validateDDMMYYYY,
    },
    age: {
      title: "Age:",
      value: getVal("age"),
      mandatory: true,
    },
    Group1: {
      title: "Gender:",
      type: "radio",
      value: getVal("gender"),
      radioOptions: ["Male", "Female"],
      mandatory: true,
    },
    nationalInsuranceNo: {
      title: "National Insurance No.:",
      value: getVal("nationalInsuranceNo"),
      type: "text",
      mandatory: true,
    },
    addressLine1: {
      title: "Address Line 1:",
      value: getVal("addressLine1"),
      type: "text",
      mandatory: true,
    },
    addressLine2: {
      title: "Address Line 2:",
      value: getVal("addressLine2"),
      type: "text",
    },
    postTown: {
      title: "Town:",
      value: getVal("postTown"),
      type: "text",
      mandatory: true,
    },
    county: {
      title: "County:",
      value: getVal("county"),
      type: "text",
      mandatory: true,
    },
    postCode: {
      title: "Postcode:",
      value: getVal("postCode"),
      type: "text",
      mandatory: true,
    },
    mobileTelephone: {
      title: "Mobile Tel:",
      value: getVal("mobileTelephone"),
      type: "text",
      mandatory: true,
    },
    homeTelephone: {
      title: "Home Tel:",
      value: getVal("homeTelephone"),
      type: "text",
    },
    emailAddress: {
      title: "Email Address",
      value: getVal("emailAddress"),
      type: "text",
      mandatory: true,
    },
    rtw: {
      title: "Do you have the legal right to work in the UK or Ireland?",
      type: "checkbox",
      value: getVal("rtw"),
      mandatory: true,
    },
    passport: {
      title:
        "British/Irish/Jersey/EU Member State Passport Number (if you don't have a passport, please enter N/A)",
      value: getVal("passport"),
      type: "text",
      mandatory: true,
    },
    nonEC: {
      title: "(Non-EC) Work Permit/Home Office documents",
      value: getVal("nonEC"),
      type: "text",
    },
    blurbSection2: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Driving Licence and Vehicle Details"} />
        </div>
      ),
    },
    Group2: {
      title: "Type of Driving Licence",
      type: "radio",
      value: getVal("Group2"),
      radioOptions: [
        "Manual",
        "Automatic",
        "Provisional",
        "Motorbike",
        "Non-EU/Other",
      ],
    },
    drivingLicenceNumber: {
      title: "Driving Licence Number",
      value: getVal("drivingLicenceNumber"),
      type: "text",
    },
    endorsements: {
      title: "Endorsements",
      value: getVal("endorsements"),
      type: "text",
    },
    carParkPass: {
      title: "Is car park pass required?",
      type: "checkbox",
      value: getVal("carParkPass"),
    },
    carRegistration: {
      title: "Car Registration",
      type: "text",
      value: getVal("carRegistration"),
    },
    blurbSection3: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Criminal Record"} />
        </div>
      ),
    },
    convicted: {
      title: "Have you ever been convicted of a criminal offence?",
      type: "checkbox",
      value: getVal("convicted"),
      mandatory: true,
    },
    proceedingsPending: {
      title: "Are there any criminal proceedings against you pending?",
      type: "checkbox",
      value: getVal("proceedingsPending"),
      mandatory: true,
    },
    proceedingsDetails: {
      title: "If Yes, give details",
      value: getVal("proceedingsDetails"),
      mandatory: true,
      dependOnAny: [
        { fieldKey: "proceedingsPending" },
        { fieldKey: "convicted" },
      ],
    },
    criminalBlurb: {
      htmlObj: (
        <div>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Note: Spent convictions under the Rehabilitation of Offenders Act
            1974 need not be declared.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Except for some Head Office Personnel all employees must have a
            Security Pass. To qualify for this pass staff must provide a
            criminal record check basic disclosure certificate (or overseas
            criminal record certificate) which does not carry any unspent
            disqualifying offences for issuing a security pass. We will tell you
            how to obtain this check and provide details of disqualifying
            offences. Employment may be conditional on a satisfactory result of
            such a check.
          </p>
        </div>
      ),
    },
    blurbSection4: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Emergency Contact"} />
        </div>
      ),
    },
    ECLastName: {
      title: "Last Name",
      value: getVal("ECLastName"),
      type: "text",
      mandatory: true,
    },
    ECFirstName: {
      title: "First Name",
      value: getVal("ECFirstName"),
      type: "text",
      mandatory: true,
    },
    ECRelationship: {
      title: "Relationship",
      value: getVal("ECRelationship"),
      type: "text",
      mandatory: true,
    },
    ECAddress: {
      title: "Address",
      value: getVal("ECAddress"),
      type: "text",
      mandatory: true,
    },
    ECPostCode: {
      title: "Postcode",
      value: getVal("ECPostCode"),
      type: "text",
      mandatory: true,
    },
    ECTel: {
      title: "Contact Tel",
      value: getVal("ECTel"),
      type: "text",
      mandatory: true,
    },
    blurbSection9: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Declaration"} />
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Information contained in this form shall be protected in accordance
            with the principles of the Data Protection Act 1998 (UK), Data
            Protection Act 1998 (Ireland) and Data Protection (Jersey) Law 2005,
            and will not be divulged to any third party unless the information
            is required for ID pass application purposes by a nominated
            referencing company or the relevant airport authority. We also
            reserve the right to share information with relevant authorities to
            prevent fraud or a criminalact.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            I authorise the Civil Aviation Authority (CAA) and/or Department for
            Transport (DfT), acting on behalf of the Secretary of State, to
            carry out a Counter Terrorism Check (CTC) if I am to be deployed on
            an activity specifically relating to aviation security, and that
            deployment on such activities is conditional on a satisfactory
            result of such a check.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            I confirm that to the best of my knowledge and belief the
            information given above is complete and accurate. I understand that
            false or inaccurate information may disqualify me from employment,or
            make me liable to summary dismissal, in appropriate cases, criminal
            charges.
          </p>
        </div>
      ),
    },
    declarationPIF: {
      title: "I understand and agree to the declaration above.*",
      value: getVal("declarationPIF"),
      type: "singlecheckbox",
      mandatory: true,
      validate: validateTrue,
    },
    blurbSection10: {
      htmlObj: (
        <HorizontalLine
          desc="
        You should notify the Company promptly in writing of any changes in your personal circumstances, in certain situations we may request proof of a change. For example, where a name change occurs you will be required to present an original document evidencing the change such as a marriage certificate or passport.
        "
        />
      ),
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    const dateOfBirthFormatted = fields.dateOfBirth.value.replace(/\//g, "");
    const dateOfBirthIntoObject = dateOfBirthFormatted
      .split("")
      .splice(0, 8)
      .reduce((acc, v, i) => ({ ...acc, [`dateOfBirth${i + 1}`]: v }), {});

    const dateFormatted = moment().format("DDMMYYYY");
    const dateIntoObject = dateFormatted
      .split("")
      .splice(0, 8)
      .reduce((acc, v, i) => ({ ...acc, [`date${i + 1}`]: v }), {});

    const ninObj = fields.nationalInsuranceNo.value
      .split("")
      .slice(0, 9)
      .reduce((acc, v, i) => ({ ...acc, [`nin${i + 1}`]: v }), {});

    const postCodeObj = fields.postCode.value
      .split("")
      .slice(0, 8)
      .reduce((acc, v, i) => ({ ...acc, [`postCode${i + 1}`]: v }), {});

    const postCodeECObj = fields.ECPostCode.value
      .split("")
      .slice(0, 8)
      .reduce((acc, v, i) => ({ ...acc, [`postCodeEC${i + 1}`]: v }), {});

    postSwissportFormFunc("personalInformationForm", {
      ...fieldValuesPayload,
      ...dateOfBirthIntoObject,
      ...dateIntoObject,
      ...ninObj,
      ...postCodeObj,
      ...postCodeECObj,
    });
    history.push("/profile/edit/swissport-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Personal Information Form"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/swissport-onboarding")}
      onboardingBranch={"swissport"}
    />
  );
};
PersonalInformationForm.propTypes = {
  appData: any,
  postSwissportFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postSwissportFormFunc: postSwissportForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(PersonalInformationForm);
